import http from "../http-common";

class QuestionariService {
  listQuestionaris() {
    return http.get("/questionari/list");
  }
  getQuestionari(idQuestionari) {
    return http.get("/questionari/"+idQuestionari);
  }
}

export default new QuestionariService();